import { displayAdsLog } from '../../utils/debug';
import { subscribe } from '../../podlet/events';
import { injectASFHToContainer } from '../../hooks/adSense';
import { addSlotToRecommendation } from '../web-components/utils';

type GoogleReqData = {
    instanceId: string;
    query: string;
    position: string;
    size: {
        width: number;
        height: number;
    };
};

export function setupASFHInRecom() {
    displayAdsLog(`setupASFHInRecom`);
    subscribe('recirc-google-ad', 'init', renderGoogleAdSenseRecom);
}

function renderGoogleAdSenseRecom(event) {
    const googleRequestData = event.payload as GoogleReqData;

    const { instanceId } = googleRequestData;
    displayAdsLog(`loadGoogleAd: ${instanceId}`);

    if (!('_googCsa' in window) || !instanceId) {
        return;
    }
    const { query, size } = googleRequestData;

    addSlotToRecommendation(instanceId);

    injectASFHToContainer(
        instanceId,
        query,
        'feed',
        'recirc-object',
        size.width,
        size.height,
    );
}
